import { useState, useEffect } from 'react';

export interface Period {
  day: number; // 1 based indexing
  month: number; // 0 based indexing
}

export interface ActivationRules {
  start: Period; // inclusive
  end: Period; // inclusive
}

export function isDateActive(rules: ActivationRules, date: Date): boolean {
  return (
    date.getMonth() >= rules.start.month &&
    date.getDate() >= rules.start.day &&
    date.getMonth() <= rules.end.month &&
    date.getDate() <= rules.end.day
  );
}

/**
 * @param expiresAt Time in seconds
 * @returns distance in seconds from expiration
 */
export function useTimer(expiresAt: number): number {
  const [time, setTime] = useState<number>(() => Date.now());
  useEffect(() => {
    const interval = setInterval(() => setTime(Date.now()), 1000);
    return () => clearInterval(interval);
  }, []);
  return expiresAt - Math.floor(time / 1000);
}

function padNumberLeft(num: number, length: number): string {
  return num.toString().padStart(length, '0');
}

/**
 * @param time Time in seconds
 * @returns Formatted time string
 */
export function timerToString(time: number): string {
  if (time < 0) return '00:00';

  const seconds = Math.floor(time) % 60;
  const minutes = Math.floor(time / 60) % 60;
  const hours = Math.floor(time / 60 / 60) % 24;
  const days = Math.floor(time / 60 / 60 / 24);

  const termDays = days > 0 ? days + ':' : '';
  const termHours = days > 0 || hours > 0 ? hours + ':' : '';
  const termMinutes = padNumberLeft(minutes, 2);
  const termSeconds = padNumberLeft(seconds, 2);

  return `${termDays}${termHours}${termMinutes}:${termSeconds}`;
}
